export const emptyFormData = {
    departStation: '', 
    arriveStation: '', 
    travelDate: '', 
    maxPrice: '', 
    minArrivalTime: '', 
    maxArrivalTime: '', 
    phoneNumber: ''
};